module.exports = __webpack_public_path__ + "static/media/testAmountContentImg.edd3a028.png";